import { UserAccessRightsGuard } from './../role/user-role/user-access-rights.guard'
import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { SaleCreateComponent } from './create/show.component'
import { SaleIndexComponent } from './index/index.component'
import { SaleActionsMainTabComponent } from './sale-actions-tab/sale-actions-tab.component'
import { SaleActivitiesMainTabComponent } from './sale-activities-tab/sale-activities-tab.component'
import { SaleGeneralMainTabComponent } from './sale-general-tab/sale-general-tab.component'
import { SaleShowComponent } from './show/show.component'
import { SaleDocumentsTabComponent } from './documents-tab/show.component'
import { BookingTableComponent } from '../booking/booking-table/table.component'
import { SaleOrganizeTabComponent } from './organize-tab/show.component'
import { AccessRights } from '../role/user-role/user-role'
import { SaleCommunicationTabComponent } from './communication-tab/communication-tab.component'
import { SurveyAnswersComponent } from '../survey/answers-tab/show.component'
import { OperationTabComponent } from './operation-tab/operation-tab.component'

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: SaleIndexComponent,
    canActivate: [UserAccessRightsGuard],
    data: { accessRights: [AccessRights.Sales_read] }
  },
  {
    path: 'create',
    component: SaleCreateComponent,
    canActivate: [UserAccessRightsGuard],
    data: { accessRights: [AccessRights.Sales_write] }
  },
  {
    path: ':saleId',
    component: SaleShowComponent,
    canActivate: [UserAccessRightsGuard],
    data: { accessRights: [AccessRights.Sales_read] },
    children: [
      { path: '', component: SaleGeneralMainTabComponent, pathMatch: 'full' },
      { path: 'activities', component: SaleActivitiesMainTabComponent },
      { path: 'actions', component: SaleActionsMainTabComponent },
      { path: 'documents', component: SaleDocumentsTabComponent },
      { path: 'organize', component: SaleOrganizeTabComponent },
      { path: 'bookings', component: BookingTableComponent },
      { path: 'operations', component: OperationTabComponent },
      { path: 'communication', component: SaleCommunicationTabComponent },
      { path: 'surveys', component: SurveyAnswersComponent }
    ]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SaleRoutingModule {}
